import React from 'react';
import { ButtonContainer, VerifyEmailHeader, VerifyEmailSubHeader } from './VerifyEmailWallStyles';
import EmailInputV2 from '../../atoms/EmailInputV2';
import { useDispatch } from 'react-redux';
import { verifyChangeNewEmail } from '../../actions/authActions';
import { FONT_FAMILIES } from '../../theme/material/constants';
import Button from '../../atoms/buttons/Button';
import colors, { primaryBG } from '../../theme/colors';
import { getInputTheme } from '../../style';
import { isDarkMode } from '../../utils/helpers';

interface IVerifyEmailStepProps {
  email: string;
  setEmail: (email: string) => void;
  data: any;
}

const VerifyEmailStep: React.FC<IVerifyEmailStepProps> = ({ setEmail, email, data }) => {
  const [canSendverification, setCanSendverification] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>('');

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (data?.error?.message) {
      setErrorMessage(data.error.message);
      setCanSendverification(false);
    }
  }, [data]);

  const handleSubmit = (): void => {
    dispatch(verifyChangeNewEmail(email, 'verify_email_wall'));
  };

  const onEmailChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setEmail(event.target.value);

    if (event.target.value.length > 0) {
      setErrorMessage('');
      !canSendverification && setCanSendverification(true);

      return;
    }

    canSendverification && setCanSendverification(false);
  };

  return (
    <div>
      <VerifyEmailHeader>{`Uh oh!`}</VerifyEmailHeader>
      <VerifyEmailSubHeader>
        {`There’s a problem with your email. Please submit a new email and we’ll send you a one-time passcode for verification.`}
      </VerifyEmailSubHeader>

      <EmailInputV2
        id={'email'}
        inputLabel="Email"
        value={email}
        onChange={onEmailChange}
        onError={hasError => {
          if (hasError) setCanSendverification(false);
        }}
        status={errorMessage && 'error'}
        statusMessage={errorMessage}
        autoFocus
        type={'login'}
        customStyle={{ marginTop: 30, marginRight: 0, width: '100%' }}
        customInputStyle={{
          fontSize: '15px !important',
          fontWeight: 400,
          lineHeight: '20px !important',
          letterSpacing: '-0.3px',
          color: `${getInputTheme().textInput} !important`,
          background: `${isDarkMode() ? colors.blue['800'] : primaryBG} !important`,
        }}
        placeHolder="Enter email address"
      />

      <ButtonContainer>
        <Button
          buttonType="primaryRed"
          type="button"
          data-test-id="close-preview"
          onClick={handleSubmit}
          disabled={!canSendverification}
          customStyle={{
            minWidth: 192,
            lineHeight: '16px',
            height: 'auto',
            fontFamily: FONT_FAMILIES.primary,
            margin: '0 auto',
            fontSize: 14,
            fontWeight: 600,
            padding: '12px 22px',
            borderRadius: '4px !important',
            // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
            '&:disabled': {
              background: `${colors.gray['200']} !important`,
              border: 'none',
              color: '#fff !important',
            },
            marginBottom: 15,
          }}
        >
          Send Verification
        </Button>
      </ButtonContainer>
    </div>
  );
};

export default VerifyEmailStep;
